import React, { useState, useEffect, useMemo } from 'react';
import { useUserContext } from '../UserContext';
import { useEntidadeContext } from '../EntidadeContext';
import logoImage from '../img/logo.png';
import PerfisTab from '../components/perfis/PerfisTab';

const PerfisPage = () => {
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig, dynamicAccessConfig } = useUserContext();
    const { currentEntidade } = useEntidadeContext();

    const permittedTabs = useMemo(() => {
        return getPermittedInternalTabs('perfis', currentUserRole);
    }, [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig, dynamicAccessConfig]);

    const [activeTabKey, setActiveTabKey] = useState(permittedTabs[0]?.key || 'gerenciarPerfis');

    useEffect(() => {
        if (permittedTabs.length > 0 && !isLoadingAccessConfig && !permittedTabs.some(tab => tab.key === activeTabKey)) {
            setActiveTabKey(permittedTabs[0].key);
        }
    }, [permittedTabs, activeTabKey, isLoadingAccessConfig]);

    return (
        <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                .perfis-tab-btn {
                    padding: 12px 18px; border: none; background: none;
                    font-size: calc(13px * var(--font-scale)) font-weight: 500; color: #6b7280;
                    border-bottom: 2px solid transparent; margin-bottom: -2px;
                    cursor: pointer; transition: all 0.15s; white-space: nowrap;
                    font-family: 'Inter', 'Segoe UI', sans-serif;
                }
                .perfis-tab-btn:hover { color: #374151; background: #f9fafb; border-radius: 6px 6px 0 0; }
                .perfis-tab-btn.active { color: #2563eb; border-bottom-color: #2563eb; font-weight: 600; }
            `}</style>

            {/* ── CABEÇALHO ── */}
            <div style={{
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                padding: '20px 28px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <img src={logoImage} alt="Logo" style={{ height: '44px', width: 'auto', opacity: 0.9 }} />
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#fff' }}>
                            Gestão de Perfis de Acesso
                        </h2>
                        <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: 'rgba(255,255,255,0.7)' }}>
                            {currentEntidade?.nome || 'Clínica'}
                        </p>
                    </div>
                </div>
                <div style={{
                    padding: '4px 12px', borderRadius: '999px',
                    backgroundColor: 'rgba(255,255,255,0.15)',
                    fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600', color: '#fff',
                    border: '1px solid rgba(255,255,255,0.25)',
                }}>
                    {currentUserRole}
                </div>
            </div>

            {/* ── ABAS ── */}
            <div style={{ backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', borderBottom: '2px solid #e2e8f0', padding: '0 24px', gap: '4px', flexWrap: 'wrap' }}>
                    {permittedTabs.map(tabInfo => (
                        <button
                            key={tabInfo.key}
                            className={`perfis-tab-btn ${activeTabKey === tabInfo.key ? 'active' : ''}`}
                            onClick={() => setActiveTabKey(tabInfo.key)}
                        >
                            {tabInfo.title}
                        </button>
                    ))}
                </div>
            </div>

            {/* ── CONTEÚDO ── */}
            <div style={{ padding: '24px 28px' }}>
                {permittedTabs.map(tabInfo => {
                    if (activeTabKey !== tabInfo.key) return null;
                    if (tabInfo.key === 'gerenciarPerfis') return (
                        <PerfisTab key={tabInfo.key} currentEntidade={currentEntidade} />
                    );
                    return null;
                })}
            </div>
        </div>
    );
};

export default PerfisPage;
